/* eslint-disable */
import React from "react";
import { useStyles } from "./styles";

export const NewsWidget = ({ children, ...props }) => {
  const childrenHeader = children[0];
  const childrenColumns = children[1];
  const ref = React.useRef<HTMLDivElement>(null);
  const classes = useStyles(props);
  const [state, setState] = React.useState({ count: 2 });

  const columns = React.useMemo(() => childrenColumns.filter((x) => x.props.role === "column"), [childrenColumns]);

  function calcSizes() {
    if (ref.current) {
      const width = ref.current!.clientWidth;
      const firstCard = ref.current!.querySelector('[role="column"]');
      if (firstCard) {
        const { width: itemWidth } = firstCard!.getBoundingClientRect();
        const count = Math.floor(width / itemWidth) || 1;
        setState({ count });
      }
    }
  }

  React.useEffect(() => {
    window.addEventListener("resize", calcSizes);
    return () => {
      window.removeEventListener("resize", calcSizes);
    };
  }, []);

  React.useEffect(calcSizes, [columns]);

  return (
    <div className={classes.root} ref={ref}>
      {childrenHeader}
      <div className={classes.columns}>{columns.slice(0, state.count)}</div>
    </div>
  );
};
NewsWidget.muiName = "NewsWidget";
NewsWidget.displayName = "NewsWidget";

export default NewsWidget;

export * from "./shared/NewsWidgetHeader";
export * from "./shared/NewsWidgetColumn";
